import leads from './leads'

export const queries = {
  leads,
}
export default queries
